var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4401 0.724976V5.74998C6.65445 5.91873 3.18008 9.43623 1.54508 12.95C-0.108672 16.5012 -0.00367187 19.9812 7.81342e-05 20.075V20.09V20.135L0.960078 20.15C0.960078 20.15 1.11383 18.0294 2.79008 15.86C4.41758 13.7543 7.51695 11.6469 13.4401 11.525V16.475L14.2051 15.89L23.3251 8.98997L23.8351 8.59998L23.3251 8.20998L14.2051 1.30998L13.4401 0.724976ZM14.4001 2.65998L22.2451 8.59998L14.4001 14.54V10.52H13.9201C7.4157 10.52 3.87383 12.8694 2.02508 15.26C1.78508 15.5694 1.6407 15.8694 1.45508 16.175C1.6707 15.2806 1.96133 14.345 2.41508 13.37C3.97883 10.01 7.11945 6.67998 13.9201 6.67998H14.4001V2.65998Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.b98232c5859f176cbead5e0dac1866bc.svg";
export { ForwardRef as ReactComponent };